// extracted by mini-css-extract-plugin
export default {"imgContain":"yB","content":"zB","titleAndImage":"AB","title":"BB","text":"CB","rhodeTitle":"EB","shortHR":"FB","modal_root":"GB","x_mark":"HB","flavorStickModal":"IB","greenBox":"JB"};
    if(module.hot) {
      // 1715276856558
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  